import PropTypes from 'prop-types';

const scenarioServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  reOrderScenarios: PropTypes.func,
  register: PropTypes.func,
  createScenario: PropTypes.func,
  getScenarioList: PropTypes.func,
  getScenario: PropTypes.func,
  updateScenario: PropTypes.func,
  subscribeToScenarioList: PropTypes.func,
  subscribeToScenario: PropTypes.func,
});

export default scenarioServiceShape;
